export enum WidgetType {
  FollowUp = 'follow-up',
  Asset = 'asset',
}
